export const phrases = [
  `Know the Ropes`,
  `Plot Thickens - The`,
  `On the Ropes`,
  `Jumping the Gun`,
  `Heads Up`,
  `Jack of All Trades Master of None`,
  `When the Rubber Hits the Road`,
  `Short End of the Stick`,
  `Elvis Has Left The Building`,
  `An Arm and a Leg`,
  `There's No I in Team`,
  `Easy As Pie`,
  `No Ifs, Ands, or Buts`,
  `My Cup of Tea`,
  `It's Not Brain Surgery`,
  `Wake Up Call`,
  `Long In The Tooth`,
  `High And Dry`,
  `Put a Sock In It`,
  `Keep Your Shirt On`,
  `Dropping Like Flies`,
  `In the Red`,
  `Elephant in the Room`,
  `Knuckle Down`,
  `Birds of a Feather Flock Together`,
  `Back To the Drawing Board`,
  `Talk the Talk`,
  `Read 'Em and Weep`,
  `Son of a Gun`,
  `Lickety Split`,
  `Cup Of Joe`,
  `Fish Out Of Water`,
  `Jaws of Life`,
  `Shot In the Dark`,
  `Like Father Like Son`,
  `Quick and Dirty`,
  `Not the Sharpest Tool in the Shed`,
  `Cry Over Spilt Milk`,
  `Rain on Your Parade`,
  `Between a Rock and a Hard Place`,
  `Swinging For the Fences`,
  `Close But No Cigar`,
  `Beating Around the Bush`,
  `Drive Me Nuts`,
  `Under Your Nose`,
  `On Cloud Nine`,
  `Hit Below The Belt`,
  `On the Same Page`,
  `Down To The Wire`,
  `Down For The Count`,
  `When money was tight, he'd get his lunch money from the local wishing well.`,
  `Shingle color was not something the couple had ever talked about.`,
  `Yeah, I think it's a good environment for learning English.`,
  `Smoky the Bear secretly started the fires.`,
  `Peanuts don't grow on trees, but cashews do.`,
  `When he encountered maize for the first time, he thought it incredibly corny.`,
  `He picked up trash in his spare time to dump in his neighbor's yard.`,
  `For oil spots on the floor, nothing beats parking a motorbike in the lounge.`,
  `If I don’t like something, I’ll stay away from it.`,
  `He embraced his new life as an eggplant.`,
  `Hang on, my kittens are scratching at the bathtub and they'll upset by the lack of biscuits.`,
  `Choosing to do nothing is still a choice, after all.`,
  `Iron pyrite is the most foolish of all minerals.`,
  `Each person who knows you has a different perception of who you are.`,
  `Nudist colonies shun fig-leaf couture.`,
  `There were white out conditions in the town; subsequently, the roads were impassable.`,
  `You've been eyeing me all day and waiting for your move like a lion stalking a gazelle in a savannah.`,
  `He went on a whiskey diet and immediately lost three days.`,
  `People generally approve of dogs eating cat food but not cats eating dog food.`,
  `He didn’t want to go to the dentist, yet he went anyway.`,
  `Toddlers feeding raccoons surprised even the seasoned park ranger.`,
  `He realized there had been several deaths on this road, but his concern rose when he saw the exact number.`,
  `The pet shop stocks everything you need to keep your anaconda happy.`,
  `The near-death experience brought new ideas to light.`,
  `It caught him off guard that space smelled of seared steak.`,
  `The lake is a long way from here.`,
  `You'll see the rainbow bridge after it rains cats and dogs.`,
  `It must be five o'clock somewhere.`,
  `He set out for a short walk, but now all he could see were mangroves and water were for miles.`,
  `The sudden rainstorm washed crocodiles into the ocean.`,
  `Just go ahead and press that button.`,
  `I covered my friend in baby oil.`,
  `She opened up her third bottle of wine of the night.`,
  `He was an introvert that extroverts seemed to love.`,
  `I am counting my calories, yet I really want dessert.`,
  `The thunderous roar of the jet overhead confirmed her worst fears.`,
  `I'm confused: when people ask me what's up, and I point, they groan.`,
  `It had been sixteen days since the zombies first attacked.`,
  `The tour bus was packed with teenage girls heading toward their next adventure.`,
  `The memory we used to share is no longer coherent.`,
  `She tilted her head back and let whip cream stream into her mouth while taking a bath.`,
  `There can never be too many cherries on an ice cream sundae.`,
  `He barked orders at his daughters but they just stared back with amusement.`,
  `The tart lemonade quenched her thirst, but not her longing.`,
  `As he entered the church he could hear the soft voice of someone whispering into a cell phone.`,
  `His confidence would have bee admirable if it wasn't for his stupidity.`,
  `She saw the brake lights, but not in time.`,
  `We have young kids who often walk into our room at night for various reasons including clowns in the closet.`,
  `Standing on one's head at job interviews forms a lasting impression.`
]
